/**
 * Conference class
 */

export default class {
  constructor (data) {
    this.id = ~~data.id
    this.name = data.name
    this.exten = this.extractExten(data.confno)
    this.confno = data.confno
    this.hasAdmin = data.add_admin
    this.pin = data.pin
    this.adminpin = data.adminpin
    this.maxusers = data.maxusers
    this.opts = data.opts
    this.members = data.members || []
    this.personal = false
    this.disabled = ~~data?.disabled === 1
  }

  /* @static */
  static find (confs, confno) {
    return confs.find((c) => c.confno === confno)
  }

  get isPersonal () { return this.personal }

  // flag for personal conferences
  get isDisabled () { return this.disabled }

  /* @public */
  setPersonal () {
    this.personal = true
  }

  addMember (data) {
    const resToBool = val => val === 'Yes'
    const isInited = val => /^Local[^@]+@confbridge-invite/.test(val)
    const astTrue = val => /^(yes|1)$/i.test(val)
    const member = {
      name: data.calleridname,
      num: data.calleridnum,
      channel: data.channel,
      marked: resToBool(data.markeduser),
      invited: isInited(data.channel),
      admin: astTrue(data.admin),
      waiting: resToBool(data.waiting),
      muted: resToBool(data.muted),
      talking: resToBool(data.talking),
      joinTime: new Date(Date.now() - (~~data.answeredtime * 1000))
    }
    // check if the channel member already exists
    const memberExists = this.members.some(m => m.channel === data.channel)
    if (!memberExists) {
      this.members.push(member)
    }
  }

  delMember (data) {
    const idx = this.members.findIndex((m) => m.channel === data.channel)
    if (idx !== -1) {
      this.members.splice(idx, 1)
    }
  }

  memberTalkig (data) {
    const member = this.members.find((m) => m.channel === data.channel)
    if (!member) {
      return // channel is not found
    }
    member.talking = data.talkingstatus === 'on'
  }

  memberMute (data) {
    const member = this.members.find((m) => m.channel === data.channel)
    if (!member) {
      return // channel is not found
    }
    member.muted = data.event === 'ConfbridgeMute'
  }

  extractExten (confno) {
    const exten = confno?.split('*')
    if (!exten) return confno
    return exten[0]
  }
}
